import { useState, useEffect } from "react";

// hook for managing column visibility with localStorage persistence
export const useColumnVisibility = (storageKey, defaultVisibility) => {
  const [columnVisibility, setColumnVisibility] = useState(() => {
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved) {
        return JSON.parse(saved);
      }
    } catch (error) {
      console.error("error loading column visibility:", error);
    }
    return defaultVisibility;
  });

  const [columnMenuOpen, setColumnMenuOpen] = useState(false);

  // automatically save when visibility changes
  useEffect(() => {
    try {
      localStorage.setItem(storageKey, JSON.stringify(columnVisibility));
    } catch (error) {
      console.error("error saving column visibility:", error);
    }
  }, [columnVisibility, storageKey]);

  return {
    columnVisibility,
    setColumnVisibility,
    columnMenuOpen,
    setColumnMenuOpen,
  };
};
